<template>
  <div class="fs-background">
    <div class="form-container">
      <div class="logo logo--wcz" />
      <template v-if="result !== 'success'">

        <v-form
          ref="form"
          v-model="valid"
        >
          <v-text-field
            autocomplete="new_password"
            solo
            v-model="password"
            validate-on-blur
            prepend-icon="fa-lock"
            :type="showPassword ? 'text' : 'password'"
            v-bind:disabled="isFetching"
            @click:append="showPassword = !showPassword"
            :append-icon=" showPassword ? 'far fa-eye-slash' : 'far fa-eye' "
            :rules="rules.password"
            :label="$t('forms.newPassword')"
            required
          ></v-text-field>
          <v-text-field
            autocomplete="new_password"
            solo
            validate-on-blur
            v-model="passwordConfirm"
            prepend-icon="fa-check-double"
            :type="showPassword ? 'text' : 'password'"
            v-bind:disabled="isFetching"
            @click:append="showPassword = !showPassword"
            :append-icon=" showPassword ? 'far fa-eye-slash' : 'far fa-eye' "
            :rules="[passwordsEqual]"
            :label="$t('forms.passwordConfirmation')"
            required
          ></v-text-field>
        </v-form>
        <div>

          <v-btn
            flat
            color="primary"
            to="/wachtwoord-herstellen"
            v-t="'buttons.back'"
          >
          </v-btn>

          <v-btn
            @click="setPassword"
            v-bind:loading="isFetching"
            color="primary"
            v-bind:disabled="isFetching || !valid"
            v-t="'buttons.setPassword'"
          >
          </v-btn>
        </div>
      </template>

      <v-icon
        medium
        v-show="result === 'success'"
        color="success"
      >fa-spin fa-circle-notch</v-icon>
      <v-alert
        :value="result === 'success'"
        type="success"
        outline
      >
        <i18n
          path="messages.passwordSet.text"
          tag="div"
          class="success--text"
        >
          <router-link
            to="/inloggen"
            class="success--text"
          >{{$t('messages.passwordSet.linkText')}}</router-link>
        </i18n>
      </v-alert>

      <v-alert
        :value="result === 'error'"
        type="error"
        outline
      >
        <msp-api-error :response="error" />
      </v-alert>

    </div>
  </div>
</template>

<script>

import { rules } from '@/helpers/forms';

export default {
  props: {
    email: String,
    token: String,
  },

  data() {
    return {
      error: null,
      valid: false,
      showPassword: false,
      password: '',
      passwordConfirm: '',
      result: null,
      rules,
    };
  },

  computed: {
    isFetching() {
      return this.$store.state.account.isFetching;
    },
    isAdmin() {
      return this.$store.state.account.isAdmin;
    },
  },

  mounted() {
    const { email, token } = this.$router.currentRoute.params;

    if (!(email && token)) {
      this.$router.replace({ name: 'resetPassword' });
    }

    this.$refs.form.reset();
    this.result = null;
  },

  methods: {
    async setPassword() {
      if (this.$refs.form.validate()) {
        this.error = null;
        const { email, token } = this.$router.currentRoute.params;

        try {
          await this.$store.dispatch('account/setPassword', {
            password: this.password, passwordConfirm: this.passwordConfirm, email, token,
          });

          this.result = 'success';

          setTimeout(() => this.$router.replace({ name: 'signIn' }), 10000);
        } catch (error) {
          this.result = 'error';
          this.error = error;
        }
      }
    },

    passwordsEqual(password) {
      return (password && password === this.password) || this.$t('validation.password.equal');
    },
  },
};
</script>

<style lang="scss">
.fs-background {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;

  &:before {
    content: "";
    position: absolute;
    // opacity: 0.8;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background-size: cover;
    background-position: center center;
    background-image: url("../assets/logos/wocozon_couple_cropped.png");
  }
}

.login {
  &__logo {
    background-image: url("../assets/logos/logo.png");
    position: absolute;
    background-size: contain;
    right: -15px;
    top: -15px;
    width: 150px;
    height: 60px;
  }
}

.form-container {
  position: absolute;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(#000, 0.2);
  box-shadow: 0 0 4px rgba(#000, 0.7);
  padding: 64px 32px;
  display: flex;
  align-items: center;
  flex-direction: column;

  .v-alert {
    margin-bottom: -24px;
    margin-top: 24px;
  }

  form {
    width: 100%;
    max-width: 400px;
  }
}
</style>

<style lang="scss" scoped>
.logo--wcz {
  position: absolute;
  top: -64px;
  height: 100px;
  width: 300px;
}

.v-alert {
  max-width: 400px;
}
</style>
